module.exports = __webpack_public_path__ + "static/img/4.f6f8f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/1/4.png
// module id = aKIx
// module chunks = 1